import React, { Component } from 'react';
import moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';

momentLocalizer(moment);

class DateFormatter extends Component {
  render() {
    const { value } = this.props;
    const date = value ? moment(value).format('MMM DD YYYY') : '-';
    return <span>{date}</span>;
    // return <div className='align-center'>-</div>;
    // return <div />;
  }
}

export default DateFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/AR/CustomerStatement/dateFormatter.jsx